import { Film, Palette, Music2, Building2, AudioLines, Headphones } from 'lucide-react';

export const CONTACT_INFO = {
  email: 'info@studio.hydroxmusic.com',
  phone: '+918822912060',
  whatsapp: '+918822912060',
  instagram: 'https://www.instagram.com/hydroxstudios',
};

export const SERVICES = [
  {
    id: 'cinematic-video-editing',
    icon: Film,
    title: 'Cinematic Video Editing',
    shortDescription: 'Precision cuts that amplify emotion and narrative flow.',
    fullDescription: 'Our cinematic video editing transforms raw footage into compelling visual stories. We focus on rhythm, pacing, and emotional impact to create content that resonates with your audience.',
    included: [
      'Multi-camera synchronization',
      'Seamless transitions & effects',
      'Audio-visual synchronization',
      'Narrative structure development',
      'Motion graphics integration',
    ],
    whoItsFor: 'Artists, filmmakers, and brands seeking professional-grade video content with a cinematic aesthetic.',
    timeline: '5-10 business days depending on project scope',
  },
  {
    id: 'color-grading',
    icon: Palette,
    title: 'Color Grading',
    shortDescription: 'Cinematic color science that defines your visual identity.',
    fullDescription: 'Professional color grading that establishes mood, enhances storytelling, and creates a distinctive visual signature for your content.',
    included: [
      'Primary & secondary color correction',
      'Custom LUT development',
      'Skin tone optimization',
      'Scene-to-scene matching',
      'Final delivery in multiple formats',
    ],
    whoItsFor: 'Filmmakers, music video directors, and content creators seeking a polished, cohesive visual identity.',
    timeline: '3-7 business days',
  },
  {
    id: 'music-videos',
    icon: Music2,
    title: 'Music Videos',
    shortDescription: 'Visual storytelling that amplifies your sound.',
    fullDescription: 'End-to-end music video production from concept development to final delivery. We create visuals that complement and enhance your music.',
    included: [
      'Concept development & storyboarding',
      'Professional cinematography',
      'Complete post-production',
      'Color grading & VFX',
      'Multiple format exports',
    ],
    whoItsFor: 'Independent artists, labels, and musicians looking to create impactful visual content for their releases.',
    timeline: '2-4 weeks for complete production',
  },
  {
    id: 'brand-films',
    icon: Building2,
    title: 'Brand Films',
    shortDescription: 'Compelling narratives that define your brand.',
    fullDescription: 'Strategic brand films that communicate your values, story, and vision. We craft content that builds connection with your target audience.',
    included: [
      'Brand strategy consultation',
      'Script & storyboard development',
      'Professional production',
      'Complete post-production',
      'Multi-platform optimization',
    ],
    whoItsFor: 'Startups, established brands, and organizations seeking to communicate their story effectively.',
    timeline: '3-6 weeks depending on complexity',
  },
  {
    id: 'audio-mixing',
    icon: AudioLines,
    title: 'Audio Mixing',
    shortDescription: 'Balanced, dynamic mixes that bring your vision to life.',
    fullDescription: 'Professional audio mixing that balances every element of your track, creating clarity, depth, and impact while maintaining your artistic vision.',
    included: [
      'Multi-track mixing',
      'EQ & compression',
      'Spatial processing',
      'Vocal treatment',
      'Unlimited revisions',
    ],
    whoItsFor: 'Musicians, producers, and artists seeking radio-ready mixes that compete professionally.',
    timeline: '3-5 business days per track',
  },
  {
    id: 'audio-mastering',
    icon: Headphones,
    title: 'Audio Mastering',
    shortDescription: 'Final polish for commercial-ready releases.',
    fullDescription: 'The final step in audio production. We optimize your mixes for all playback systems and streaming platforms while preserving dynamics and punch.',
    included: [
      'Loudness optimization',
      'Stereo enhancement',
      'Frequency balancing',
      'Format conversion',
      'Platform-specific masters',
    ],
    whoItsFor: 'Artists, labels, and producers preparing music for commercial release and streaming platforms.',
    timeline: '1-3 business days per track',
  },
];

export const PROCESS_STEPS = [
  {
    number: '01',
    title: 'Discovery',
    description: 'We begin with understanding your vision, goals, and creative direction through detailed consultation.',
  },
  {
    number: '02',
    title: 'Planning',
    description: 'Strategic planning and timeline development to ensure structured execution and clear deliverables.',
  },
  {
    number: '03',
    title: 'Execution',
    description: 'Professional production with regular updates and feedback loops to maintain alignment.',
  },
  {
    number: '04',
    title: 'Delivery',
    description: 'Final delivery with revisions, ensuring your complete satisfaction with the end result.',
  },
];

export const WHY_CHOOSE_US = [
  {
    title: 'Structured Execution',
    description: 'Clear timelines, defined deliverables, and professional project management throughout.',
  },
  {
    title: 'Cinematic Aesthetic',
    description: 'Every project benefits from our refined visual and audio sensibility.',
  },
  {
    title: 'Transparent Pricing',
    description: 'No hidden costs. Clear quotes with detailed breakdowns before we begin.',
  },
  {
    title: 'Professional Workflow',
    description: 'Industry-standard tools and processes ensuring consistent, high-quality results.',
  },
];

export const PORTFOLIO_PLACEHOLDERS = [
  {
    id: 'music-video-placeholder',
    title: 'Music Video',
    category: 'Video Production',
    image: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 'brand-film-placeholder',
    title: 'Brand Film',
    category: 'Commercial',
    image: 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 'audio-mastering-placeholder',
    title: 'Audio Mastering',
    category: 'Audio Production',
    image: 'https://images.unsplash.com/photo-1571397014431-ac18cf9a0d31?auto=format&fit=crop&w=800&q=80',
  },
];

export const NAV_LINKS = [
  { name: 'Home', path: '/' },
  { name: 'Services', path: '/services' },
  { name: 'Work', path: '/work' },
  { name: 'About', path: '/about' },
  { name: 'Get a Quote', path: '/contact' },
];

export const SERVICE_TYPES = [
  'Cinematic Video Editing',
  'Color Grading',
  'Music Videos',
  'Brand Films',
  'Audio Mixing',
  'Audio Mastering',
  'Other',
];
